window.addEventListener('beforeunload', function () {
  $('#page_cover').show();
    window.scrollTo(0, 0);
  });

/*! For license information please see qrevoc_main.js.LICENSE.txt */ ! function() {
    var e = {
            "./src/js/main.js": function(e, t, s) {
                "use strict";
                s("jquery");
                var n = s("./node_modules/split-type/dist/index.js"),
                    i = s("./src/widgets/debug.js"),
                    o = s("jquery");
                (0, i.debugfunction)();
                var r = document.documentElement.clientHeight || window.innerHeight,
                    c = (document.documentElement.clientWidth || window.innerWidth) < 750,
                    a = o(window).scrollTop();

                function p() {
                    return o("#play-video-text").width() / o("#play-video-line-box").width() * 100
                }
                o(window).on("scroll", (function(e) {
                    var t = o(window).scrollTop();
                    t > a ? "down" : "up", a = t, o(o.CN(".product-container .section")).each((function(e, t) {
                        var s = o(t).data("section");
                        1 === s || 2 === s || 9 === s && function(e) {
                            var t = e.getBoundingClientRect(),
                                s = t.top;
                            t.right, t.bottom, t.left;
                            s < r / 2 ? (o(o.CN(".section-ninth .gradient-box")).addClass(o.CN("breathing-light-ani")), o(o.CN(".section-ninth .icon1")).addClass(o.CN("icon1-ani")), o(o.CN(".section-ninth .icon2")).addClass(o.CN("icon2-ani")), o(o.CN(".section-ninth .icon3")).addClass(o.CN("icon3-ani")), o(o.CN(".section-ninth .icon4")).addClass(o.CN("icon4-ani")), o(o.CN(".section-ninth .icon5")).addClass(o.CN("icon5-ani"))) : (o(o.CN(".section-ninth .gradient-box")).removeClass(o.CN("breathing-light-ani")), o(o.CN(".section-ninth .icon1")).removeClass(o.CN("icon1-ani")), o(o.CN(".section-ninth .icon2")).removeClass(o.CN("icon2-ani")), o(o.CN(".section-ninth .icon3")).removeClass(o.CN("icon3-ani")), o(o.CN(".section-ninth .icon4")).removeClass(o.CN("icon4-ani")), o(o.CN(".section-ninth .icon5")).removeClass(o.CN("icon5-ani")))
                        }(t)
                    }))
                })), o(window).on("resize", (function(e) {})), o((function() {
                    o(o.CN(".fadein-up")).each((function() {
                        gsap.set(o(this), {
                            opacity: 0,
                            y: 60
                        }), gsap.fromTo(o(this), {
                            y: 60,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            duration: .5,
                            ease: "power2.easeOut",
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: o(this),
                                start: "top-=".concat(c ? "60px" : "0", " bottom-=") + "15%",
                                end: "top-=".concat(c ? "60px" : "0", " bottom-=") + "15%",
                                invalidateOnRefresh: !0,
                                // toggleActions: "play none reverse none"
                                toggleActions: "play none none none"
                            },
                            delay: Number(o(this).attr("delay")) || 0
                        })
                    })), o(o.CN(".container-fadein-up-list")).each((function() {
                        var e = o(this).attr("start") || "30%",
                            t = gsap.timeline({
                                scrollTrigger: {
                                    trigger: o(this),
                                    start: "top bottom-=" + (c ? "15%" : e),
                                    end: "top+=50px bottom-=" + (c ? "15%" : "10%"),
                                    invalidateOnRefresh: !0,
                                    // toggleActions: "play none reverse none"
                                    toggleActions: "play none none none"
                                },
                                onComplete: function() {
                                    ScrollTrigger.refresh()
                                }
                            });
                        o(this).find(o.CN(".fadein-up-list")).each((function(e, s) {
                            gsap.set(o(s), {
                                opacity: 0,
                                y: 100
                            }), t.fromTo(o(s), {
                                y: 100,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power0.easeOut",
                                immediateRender: !0
                            }, "<40%")
                        }))
                    })), setTimeout((function() {
                        o(o.CN(".offset-view")).each((function() {
                            var e = gsap.timeline();
                            e.add(gsap.fromTo(o(this).find("img"), {
                                scale: 1.1,
                                y: "-4.9%"
                            }, {
                                scale: 1.1,
                                y: "4.9%",
                                ease: "sine.inOut",
                                immediateRender: !0,
                                duration: 1
                            })), ScrollTrigger.create({
                                animation: e,
                                trigger: this,
                                start: "top bottom-=0%",
                                end: "bottom top+=0%",
                                invalidateOnRefresh: !0,
                                scrub: 1
                            })
                        }))
                    }), 100), document.querySelectorAll(o.CN(".gsap-word-by-word")).forEach((function(e, t) {
                        var s = {
                                pin: !1,
                                pinSpacing: !0,
                                trigger: e,
                                start: "top center",
                                end: "+=300px",
                                scrub: !0,
                                toggleActions: "play play reverse reverse"
                            },
                            i = gsap.timeline({
                                scrollTrigger: s
                            }),
                            o = new n.default(e, {
                                types: "words"
                            });
                        i.fromTo(o.words, {
                            color: "#C1C1C1"
                        }, {
                            color: "#000000",
                            duration: .3,
                            stagger: .2,
                            opacity: 1
                        }), i.to({}, {}, "+=1")
                    })), gsap.fromTo(o(o.CN(".section-first .text-area")), {
                        y: 60,
                        opacity: 0
                    }, {
                        y: 0,
                        opacity: 1,
                        duration: .5,
                        ease: "power2.easeOut"
                    }), o(o.CN(".section-third .section-wrap")).on({
                        mouseenter: function() {
                            gsap.to(o.CN(".section-third .line-box .line-left"), 1, {
                                width: "80%",
                                ease: "power3.out"
                            })
                        },
                        mouseleave: function() {
                            gsap.to(o.CN(".section-third .line-box .line-left"), 1, {
                                width: p() + "%",
                                ease: "power3.out"
                            })
                        }
                    }), ScrollTrigger.create({
                        trigger: o.CN(".section-sixth .number"),
                        start: "top bottom-=35%",
                        end: "top+=" + (c ? 100 : 200) + " bottom-=35%",
                        onEnter: function() {
                            gsap.to({
                                progress: 0
                            }, {
                                progress: 1,
                                duration: 2,
                                ease: "power3.out",
                                onUpdate: function() {
                                    var e = "",
                                        t = Math.round(12e3 * this.targets()[0].progress);
                                    e = ",", t = t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, e), o(o.CN(".section-sixth .number")).text(t)
                                }
                            })
                        },
                        scrub: .3,
                        invalidateOnRefresh: !0,
                        id: "s6"
                    })
                })), window.onload = function() {
                    o("#play-video-line").css("width", p() + "%")
                }
            },
            "./src/widgets/AlbumCart/index.js": function(e, t, s) {
                "use strict";

                function n() {
                    // document.documentElement.clientWidth || window.innerWidth;
                    // var e = new Swiper("#albumSwiper", {
                    //     loop: !0,
                    //     effect: "cards",
                    //     grabCursor: !0
                    // });
                    // document.querySelector("#albumSwiper").addEventListener("click", (function() {
                    //     e.slideNext()
                    // }))
                }
                s.d(t, {
                    default: function() {
                        return n
                    }
                })
            },
            "./src/widgets/Album/index.js": function(e, t, s) {
                "use strict";

                function n() {
                    document.documentElement.clientWidth || window.innerWidth;
                    new Swiper("#qSwiperalbum", {
                        grabCursor: !0,
                        speed: 2e4,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    }), new Swiper("#qSwiperalbum-1", {
                        grabCursor: !0,
                        speed: 16e3,
                        loop: !0,
                        slidesPerView: "auto",
                        a11y: {
                            slideRole: "listitem"
                        },
                        autoplay: {
                            pauseOnMouseEnter: !0,
                            disableOnInteraction: !1,
                            delay: 0
                        }
                    })
                }
                s.d(t, {
                    default: function() {
                        return n
                    }
                })
            },
            "./src/widgets/ClassExtension.js": function(e, t, s) {
                ! function(e) {
                    e.extend({
                        CN: function(e) {
                            return e.startsWith(".") ? e.split(" ").map((function(e) {
                                return e.startsWith(".") ? ".".concat("qrevoc_").concat(e.slice(1)) : e
                            })).join(" ") : "qrevoc_" + e
                        }
                    })
                }(s("jquery"))
            },
            "./src/widgets/ContrastContainer/index.js": function(e, t, s) {
                "use strict";
                var n = s("jquery");

                function i(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, t) {
                        var s = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != s) {
                            var n, i, o, r, c = [],
                                a = !0,
                                p = !1;
                            try {
                                if (o = (s = s.call(e)).next, 0 === t) {
                                    if (Object(s) !== s) return;
                                    a = !1
                                } else
                                    for (; !(a = (n = o.call(s)).done) && (c.push(n.value), c.length !== t); a = !0);
                            } catch (e) {
                                p = !0, i = e
                            } finally {
                                try {
                                    if (!a && null != s.return && (r = s.return(), Object(r) !== r)) return
                                } finally {
                                    if (p) throw i
                                }
                            }
                            return c
                        }
                    }(e, t) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return o(e, t);
                        var s = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === s && e.constructor && (s = e.constructor.name);
                        if ("Map" === s || "Set" === s) return Array.from(e);
                        if ("Arguments" === s || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s)) return o(e, t)
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function o(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var s = 0, n = new Array(t); s < t; s++) n[s] = e[s];
                    return n
                }
                n((function() {
                    var e = document.documentElement.clientWidth || window.innerWidth;
                    ! function() {
                        if (document.getElementById("compare_data")) {
                            var t, s = JSON.parse(document.getElementById("compare_data").text),
                                o = (t = s, JSON.parse(JSON.stringify(t)));
                            r(s), n(n.CN(".contrast-container")).on("click", n.CN(".h4"), (function() {
                                var e = this;
                                n(n.CN(".contrast-container .h4")).each((function(t, s) {
                                    s !== e && n(s).children(n.CN(".popup")).hide()
                                })), n(this).children(n.CN(".popup")).toggle()
                            })), n(document).on("click", (function(e) {
                                n(e.target).closest(n.CN(".contrast-container .h4")).length || n(n.CN(".contrast-container .popup")).hide()
                            })), n(n.CN(".contrast-container")).on("click", n.CN(".h4 .modlist"), (function(e) {
                                var t = n(this).attr("productname"),
                                    i = n(this).attr("parentlevel");
                                o[i] = s[t], r(o)
                            }))
                        }

                        function r(t) {
                            var o = "";
                            Object.entries(t).forEach((function(t, n) {
                                var r = i(t, 2),
                                    c = r[0],
                                    a = r[1];
                                n > (e > 750 ? 2 : 1) || (o += '<div class="'.concat("qrevoc_", 'item">\n          <img src="').concat(a.imgsrc, '" alt="').concat(a.name, '">\n          <div class="').concat("qrevoc_", 'h4">').concat(a.name, '\n            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M1.5 1L6.5 6L11.5 1" stroke="#DB2D30" stroke-width="2" stroke-linecap="round"/>\n            </svg>\n            <div class="').concat("qrevoc_", 'popup">\n              <div class="').concat("qrevoc_", 'models">').concat(a.choose, "</div>"), Object.entries(s).forEach((function(e) {
                                    var t = i(e, 2),
                                        s = t[0],
                                        n = t[1];
                                    o += '<p class="'.concat("qrevoc_", 'modlist" parentlevel="').concat(c, '" productname="').concat(s, '">\n                <svg class="').concat(a.name == n.name ? "".concat("qrevoc_", "active") : "", '" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M1.33346 3L4.33354 6L10.0002 1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>\n                </svg><span>').concat(n.name, "</span></p>")
                                })), o += "</div>\n          </div>\n          <div>", a.open_purchase ? o += '<button class="'.concat("qrevoc_", 'buy-now purchase-sales-channel-btn" product-name="').concat(a.name.replaceAll(" ", "-").replaceAll("Roborock-", ""), '" data-toggle="modal" data-target="#product-sales-channel">').concat(a.btntext, "</button>") : a.show_link_btn ? o += '<a href="'.concat(a.btn_link, '"><button class="').concat("qrevoc_", 'buy-now">').concat(a.btntext, "</button></a>") : o += '<div class="'.concat("qrevoc_", 'no_btn"></div>'), o += "</div>\n          <ul>", Object.entries(a).forEach((function(e) {
                                    var t = i(e, 2),
                                        s = t[0],
                                        n = t[1];
                                    s.includes("item") && (o += "<li>".concat(n, "</li>"))
                                })), o += "</ul>\n        </div>")
                            })), n("#compare-table").html(o), "function" == typeof ReloadSalesChannelEvents && ReloadSalesChannelEvents()
                        }
                    }()
                }))
            },
            "./src/widgets/FullScreenVideo/index.js": function(e, t, s) {
                "use strict";
                var n = s("jquery");
                n((function() {
                    function e() {
                        n(n.CN(".full_screen_video")).hide();
                        var e = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(e)
                    }! function() {
                        var e = document.querySelectorAll(n.CN(".as-youtube-video"));
                        if (e.length > 0) {
                            var t = document.createElement("script");
                            t.src = "https://www.youtube.com/iframe_api";
                            var s = document.getElementsByTagName("script")[0];
                            s.parentNode.insertBefore(t, s);
                            var i = [],
                                o = function(e) {
                                    document.addEventListener("hide.all.modals", (function(e) {
                                        for (var t = 0; t < i.length; t++) i[t].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var t = 0; t < e.length; t++) i.push(new window.YT.Player(e[t], {
                                    events: {
                                        onReady: o
                                    }
                                }))
                            }
                        }
                    }(), n(n.CN(".section-second .video-box")).on("click", (function(e) {
                        n(n.CN(".full_screen_video")).show()
                    })), n(n.CN(".full_screen_video")).on("click", (function(t) {
                        e()
                    })), n(n.CN(".full_screen_video .video-close")).on("click", (function(t) {
                        e()
                    }))
                }))
            },
            "./src/widgets/LeftNav/index.js": function(e, t, s) {
                "use strict";
                s("jquery")
            },
            "./src/widgets/ParameterContainer/index.js": function(e, t, s) {
                "use strict";

                function n() {
                    new Swiper("#parameter-swiper", {
                        grabCursor: !0,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: !0
                        },
                        autoplay: {
                            pauseOnMouseEnter: !1,
                            disableOnInteraction: !1,
                            delay: 3e3
                        }
                    })
                }
                s.d(t, {
                    parameterSwiper: function() {
                        return n
                    }
                })
            },
            "./src/widgets/SeriseContainer/index.js": function(e, t, s) {
                "use strict";
                var n = s("jquery");
                n((function() {
                    n("#sideBtn").on("click", (function() {
                        var e = n(n.CN(".serise-container"));
                        e.hasClass(n.CN("show")) ? e.addClass(n.CN("hide")).removeClass(n.CN("show")) : e.addClass(n.CN("show")).removeClass(n.CN("hide"))
                    })), n("#popup-tab").delegate(n.CN(".tabTitle"), "click", (function(e) {
                        n(this).addClass(n.CN("active")).siblings().removeClass(n.CN("active")), n(n.CN(".tabbody .tabCard")).eq(n(this).index()).show().siblings().hide(), n(n.CN(".pc .img")).eq(n(this).index()).addClass(n.CN("active")).siblings().removeClass(n.CN("active")), n(n.CN(".mob .img")).eq(n(this).index()).addClass(n.CN("active")).siblings().removeClass(n.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(e, t, s) {
                "use strict";
                s.d(t, {
                    basics: function() {
                        return i
                    }
                });
                var n = s("jquery");

                function i() {
                    n(".ad-bar").length > 0 && n(n.CN(".container")).css({
                        "margin-top": "110px"
                    }), n("#product_subscription_b").on("click", (function() {
                        n("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
            },
            "./src/widgets/debug.js": function(e, t, s) {
                "use strict";
                s.d(t, {
                    debugfunction: function() {
                        return i
                    }
                });
                var n = s("jquery");

                function i() {
                    var e, t, s, i, o, r, c, a, p = null,
                        g = !1,
                        u = null,
                        l = null,
                        _ = null,
                        m = null;

                    function f() {
                        var e = window.innerWidth,
                            t = window.innerHeight,
                            s = window.outerWidth,
                            i = window.outerHeight;
                        p && (p.text("分辨率".concat(e, "*").concat(t, " & 窗口").concat(s, "*").concat(i)), window.innerWidth > 751 ? (n(u).css("display", "block"), n(l).css("display", "block"), n(_).css("display", "block"), n(m).css("display", "block")) : (n(u).css("display", "none"), n(l).css("display", "none"), n(_).css("display", "none"), n(m).css("display", "none")))
                    }
                    // e = window.location.href, t = new URL(e), s = t.hostname, i = t.searchParams.get("debugResolution"), !(o = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(s) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(s) && "show" != i || (g || function() {
                    //     (p = n("<div>", {
                    //         id: "resolution-container",
                    //         style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //         text: "分辨率: 加载中..."
                    //     })).appendTo("body"), g = !0, u = n("<div>", {
                    //         id: "resolution-choose-Title",
                    //         style: "position:fixed;top:10px;left:263px;z-index:9999999;color:#000;padding:5px 10px;",
                    //         text: " 分辨率大小按钮=>"
                    //     }), l = n("<a>", {
                    //         id: "resolution-choose1",
                    //         style: "position:fixed;top:10px;left:405px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1920*960"
                    //     }), _ = n("<a>", {
                    //         id: "resolution-choose2",
                    //         style: "position:fixed;top:10px;left:500px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1536*754"
                    //     }), m = n("<a>", {
                    //         id: "resolution-choose3",
                    //         style: "position:fixed;top:10px;left:592px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1280*600"
                    //     }), u.appendTo("body"), l.appendTo("body"), _.appendTo("body"), m.appendTo("body");
                    //     var e = window.location.href;
                    //     l.on("click", (function() {
                    //         window.open(e, "_blank", "width=1920,height=961")
                    //     })), _.on("click", (function() {
                    //         window.open(e, "_blank", "width=1536,height=755")
                    //     })), m.on("click", (function() {
                    //         window.open(e, "_blank", "width=1280,height=601")
                    //     }))
                    // }(), f(), o.test(s)), n(window).resize((r = f, c = 200, a = 0, function() {
                    //     var e = (new Date).getTime();
                    //     e - a >= c && (a = e, r.apply(void 0, arguments))
                    // }))
                }
            },
            "./src/widgets/index.js": function(e, t, s) {
                "use strict";
                s("./src/widgets/ContrastContainer/index.js"), s("./src/widgets/FullScreenVideo/index.js"), s("./src/widgets/LeftNav/index.js"), s("./src/widgets/SeriseContainer/index.js"), s("./src/widgets/ClassExtension.js");
                var n = s("./src/widgets/Album/index.js"),
                    i = s("./src/widgets/AlbumCart/index.js"),
                    o = s("./src/widgets/ParameterContainer/index.js"),
                    r = s("./src/widgets/basics.js");
                (0, n.default)(), (0, i.default)(), (0, o.parameterSwiper)(), (0, r.basics)()
            },
            "./src/index.html": function(e, t, s) {
                "use strict";
                var n = s("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    i = s.n(n),
                    o = new URL(s("./src/assets/images/Section1_web_image1.png"), s.b),
                    r = new URL(s("./src/assets/images/Section1_mob_image1.jpg"), s.b),
                    c = new URL(s("./src/assets/video/Section3_video.mp4"), s.b),
                    a = new URL(s("./src/assets/images/Section2_web_image1.png"), s.b),
                    p = new URL(s("./src/assets/images/Section2_mob_image1.png"), s.b),
                    g = new URL(s("./src/assets/images/Section2_web_image2.png"), s.b),
                    u = new URL(s("./src/assets/images/Section2_mob_image2.png"), s.b),
                    l = new URL(s("./src/assets/images/Section2_web_image3.png"), s.b),
                    _ = new URL(s("./src/assets/images/Section2_mob_image3.png"), s.b),
                    m = new URL(s("./src/assets/images/Section2_web_image4.png"), s.b),
                    f = new URL(s("./src/assets/images/Section2_mob_image4.png"), s.b),
                    d = new URL(s("./src/assets/images/Section2_web_image5.png"), s.b),
                    b = new URL(s("./src/assets/images/Section2_mob_image5.png"), s.b),
                    w = new URL(s("./src/assets/images/Section2_web_image6.png"), s.b),
                    S = new URL(s("./src/assets/images/Section2_mob_image6.png"), s.b),
                    h = new URL(s("./src/assets/images/Section3_web_image1.png"), s.b),
                    v = new URL(s("./src/assets/images/Section4_sign1.png"), s.b),
                    y = new URL(s("./src/assets/images/Section4_sign2.png"), s.b),
                    x = new URL(s("./src/assets/images/Section4_sign3.png"), s.b),
                    C = new URL(s("./src/assets/images/Section4_web_image1.png"), s.b),
                    j = new URL(s("./src/assets/images/Section4_web_image2.png"), s.b),
                    R = new URL(s("./src/assets/images/Section4_web_image4.png"), s.b),
                    L = new URL(s("./src/assets/images/Section5_web_image1.png"), s.b),
                    Q = new URL(s("./src/assets/images/Section5_web_image2.png"), s.b),
                    U = new URL(s("./src/assets/images/Section5_sign1.png"), s.b),
                    N = new URL(s("./src/assets/images/Section5_sign2.png"), s.b),
                    O = new URL(s("./src/assets/images/Section6_web_image1.png"), s.b),
                    E = new URL(s("./src/assets/images/Section6_web_image2.png"), s.b),
                    k = new URL(s("./src/assets/images/Section7_web_image2.png"), s.b),
                    T = new URL(s("./src/assets/images/Section7_web_image1.png"), s.b),
                    A = new URL(s("./src/assets/images/Section7_sign1.png"), s.b),
                    W = new URL(s("./src/assets/images/Section8_web_image1.png"), s.b),
                    P = new URL(s("./src/assets/images/Section8_web_image4.png"), s.b),
                    q = new URL(s("./src/assets/images/Section8_web_image2.png"), s.b),
                    D = new URL(s("./src/assets/images/Section8_web_image3.png"), s.b),
                    I = new URL(s("./src/assets/images/Section9_sign1.png"), s.b),
                    B = new URL(s("./src/assets/images/Section9_sign2.png"), s.b),
                    M = new URL(s("./src/assets/images/Section9_web_image1.jpg"), s.b),
                    F = new URL(s("./src/assets/images/Section9_mob_image1.jpg"), s.b),
                    $ = new URL(s("./src/assets/images/Section9_icon1.png"), s.b),
                    V = new URL(s("./src/assets/images/Section10_icon1.png"), s.b),
                    z = new URL(s("./src/assets/images/Section10_icon2.png"), s.b),
                    H = new URL(s("./src/assets/images/Section10_icon3.png"), s.b),
                    J = new URL(s("./src/assets/images/Section10_icon4.png"), s.b),
                    Y = new URL(s("./src/assets/images/Section10_icon5.png"), s.b),
                    X = new URL(s("./src/assets/images/Section10_icon6.png"), s.b),
                    G = new URL(s("./src/assets/images/Section10_web_image1.jpg"), s.b),
                    K = new URL(s("./src/assets/images/Section10_mob_image1.jpg"), s.b),
                    Z = new URL(s("./src/assets/images/Section11_web_image1.png"), s.b),
                    ee = new URL(s("./src/assets/images/Section11_web_image2.png"), s.b),
                    te = new URL(s("./src/assets/images/Section12_web_image1.png"), s.b),
                    se = new URL(s("./src/assets/images/Section12_web_image2.png"), s.b),
                    ne = new URL(s("./src/assets/images/Section13_web_image1.png"), s.b),
                    ie = new URL(s("./src/assets/images/Section13_sign1.png"), s.b),
                    oe = new URL(s("./src/assets/images/Section13_web_image2.png"), s.b),
                    re = new URL(s("./src/assets/images/Section14_web_image1.png"), s.b),
                    ce = new URL(s("./src/assets/images/Section14_icon1.png"), s.b),
                    ae = new URL(s("./src/assets/images/Section14_web_image2.png"), s.b),
                    pe = new URL(s("./src/assets/images/Section14_icon2.png"), s.b),
                    ge = new URL(s("./src/assets/images/Section14_web_image3.png"), s.b),
                    ue = new URL(s("./src/assets/images/Section14_icon3.png"), s.b),
                    le = new URL(s("./src/assets/images/Section14_web_image4.png"), s.b),
                    _e = new URL(s("./src/assets/images/Section15_petsnaps.jpg"), s.b),
                    me = new URL(s("./src/assets/images/Section15_phone.png"), s.b),
                    fe = new URL(s("./src/assets/images/Section15_mob_phone.png"), s.b),
                    de = new URL(s("./src/assets/images/Section15_phone_product.png"), s.b),
                    be = new URL(s("./src/assets/images/Section15_watch.jpg"), s.b),
                    we = new URL(s("./src/assets/images/Section16_web_image1.png"), s.b),
                    Se = new URL(s("./src/assets/images/Section_compare_series.png"), s.b),
                    he = new URL(s("./src/assets/images/Section_compare_slim.png"), s.b),
                    ve = new URL(s("./src/assets/images/Section_compare_master.png"), s.b),
                    ye = new URL(s("./src/assets/images/Section_compare_maxV.png"), s.b),
                    xe = new URL(s("./src/assets/images/Section_compare_pro.png"), s.b),
                    Ce = new URL(s("./src/assets/images/Section_compare_plus.png"), s.b),
                    je = new URL(s("./src/assets/images/Section_compare_l.png"), s.b),
                    Re = new URL(s("./src/assets/images/Section_compare_s.png"), s.b),
                    Le = new URL(s("./src/assets/images/Section_compare_qrevo.png"), s.b),
                    Qe = new URL(s("./src/assets/images/Section_compare_EdgeC.png"), s.b),
                    Ue = new URL(s("./src/assets/images/Section21_web_image1.jpg"), s.b),
                    Ne = new URL(s("./src/assets/images/Section21_web_image2.jpg"), s.b),
                    Oe = new URL(s("./src/assets/images/Section21_web_image3.jpg"), s.b),
                    Ee = new URL(s("./src/assets/images/Section21_web_image4.jpg"), s.b),
                    ke = new URL(s("./src/assets/images/Section21_web_image5.jpg"), s.b),
                    Te = new URL(s("./src/assets/images/Section21_web_image6.jpg"), s.b),
                    Ae = new URL(s("./src/assets/images/Section21_web_image7.jpg"), s.b),
                    We = new URL(s("./src/assets/images/Section21_web_image8.jpg"), s.b),
                    Pe = new URL(s("./src/assets/images/Section21_web_image9.jpg"), s.b),
                    qe = new URL(s("./src/assets/images/Section21_web_image10.jpg"), s.b),
                    De = new URL(s("./src/assets/images/Section21_web_image11.jpg"), s.b),
                    Ie = new URL(s("./src/assets/images/Section21_web_image12.jpg"), s.b);
                i()(o), i()(r), i()(c), i()(a), i()(p), i()(g), i()(u), i()(l), i()(_), i()(m), i()(f), i()(d), i()(b), i()(w), i()(S), i()(h), i()(v), i()(y), i()(x), i()(C), i()(j), i()(R), i()(L), i()(Q), i()(U), i()(N), i()(O), i()(E), i()(k), i()(T), i()(A), i()(W), i()(P), i()(q), i()(D), i()(I), i()(B), i()(M), i()(F), i()($), i()(V), i()(z), i()(H), i()(J), i()(Y), i()(X), i()(G), i()(K), i()(Z), i()(ee), i()(te), i()(se), i()(ne), i()(ie), i()(oe), i()(re), i()(ce), i()(ae), i()(pe), i()(ge), i()(ue), i()(le), i()(_e), i()(me), i()(fe), i()(de), i()(be), i()(we), i()(Se), i()(he), i()(ve), i()(ye), i()(xe), i()(Ce), i()(je), i()(Re), i()(Le), i()(Qe), i()(Ue), i()(Ne), i()(Oe), i()(Ee), i()(ke), i()(Te), i()(Ae), i()(We), i()(Pe), i()(qe), i()(De), i()(Ie)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(e) {
                "use strict";
                e.exports = function(e, t) {
                    return t || (t = {}), e ? (e = String(e.__esModule ? e.default : e), t.hash && (e += t.hash), t.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(e) ? '"'.concat(e, '"') : e) : e
                }
            },
            "./node_modules/split-type/dist/index.js": function(e, t, s) {
                "use strict";

                function n(e, t) {
                    for (var s = 0; s < t.length; s++) {
                        var n = t[s];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
                    }
                }

                function i(e, t, s) {
                    return t && n(e.prototype, t), s && n(e, s), e
                }

                function o(e, t, s) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: s,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = s, e
                }

                function r(e, t) {
                    var s = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable
                        }))), s.push.apply(s, n)
                    }
                    return s
                }

                function c(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var s = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? r(Object(s), !0).forEach((function(t) {
                            o(e, t, s[t])
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s)) : r(Object(s)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(s, t))
                        }))
                    }
                    return e
                }

                function a(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e
                    }(e) || function(e, t) {
                        if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
                        var s = [],
                            n = !0,
                            i = !1,
                            o = void 0;
                        try {
                            for (var r, c = e[Symbol.iterator](); !(n = (r = c.next()).done) && (s.push(r.value), !t || s.length !== t); n = !0);
                        } catch (e) {
                            i = !0, o = e
                        } finally {
                            try {
                                n || null == c.return || c.return()
                            } finally {
                                if (i) throw o
                            }
                        }
                        return s
                    }(e, t) || g(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function p(e) {
                    return function(e) {
                        if (Array.isArray(e)) return u(e)
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e)
                    }(e) || g(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                    }()
                }

                function g(e, t) {
                    if (e) {
                        if ("string" == typeof e) return u(e, t);
                        var s = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === s && e.constructor && (s = e.constructor.name), "Map" === s || "Set" === s ? Array.from(e) : "Arguments" === s || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s) ? u(e, t) : void 0
                    }
                }

                function u(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var s = 0, n = new Array(t); s < t; s++) n[s] = e[s];
                    return n
                }

                function l(e, t) {
                    return Object.getOwnPropertyNames(Object(e)).reduce((function(s, n) {
                        var i = Object.getOwnPropertyDescriptor(Object(e), n),
                            o = Object.getOwnPropertyDescriptor(Object(t), n);
                        return Object.defineProperty(s, n, o || i)
                    }), {})
                }

                function _(e) {
                    return "string" == typeof e
                }

                function m(e) {
                    return Array.isArray(e)
                }

                function f() {
                    var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                        s = l(t);
                    return void 0 !== s.types ? e = s.types : void 0 !== s.split && (e = s.split), void 0 !== e && (s.types = (_(e) || m(e) ? String(e) : "").split(",").map((function(e) {
                        return String(e).trim()
                    })).filter((function(e) {
                        return /((line)|(word)|(char))/i.test(e)
                    }))), (s.absolute || s.position) && (s.absolute = s.absolute || /absolute/.test(t.position)), s
                }

                function d(e) {
                    var t = _(e) || m(e) ? String(e) : "";
                    return {
                        none: !t,
                        lines: /line/i.test(t),
                        words: /word/i.test(t),
                        chars: /char/i.test(t)
                    }
                }

                function b(e) {
                    return null !== e && "object" == typeof e
                }

                function w(e) {
                    return b(e) && /^(1|3|11)$/.test(e.nodeType)
                }

                function S(e) {
                    return m(e) ? e : null == e ? [] : function(e) {
                        return b(e) && function(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0
                        }(e.length)
                    }(e) ? Array.prototype.slice.call(e) : [e]
                }

                function h(e) {
                    var t = e;
                    return _(e) && (t = /^(#[a-z]\w+)$/.test(e.trim()) ? document.getElementById(e.trim().slice(1)) : document.querySelectorAll(e)), S(t).reduce((function(e, t) {
                        return [].concat(p(e), p(S(t).filter(w)))
                    }), [])
                }
                s.d(t, {
                        default: function() {
                            return se
                        }
                    }),
                    function() {
                        function e() {
                            for (var e = arguments.length, t = 0; t < e; t++) {
                                var s = t < 0 || arguments.length <= t ? void 0 : arguments[t];
                                1 === s.nodeType || 11 === s.nodeType ? this.appendChild(s) : this.appendChild(document.createTextNode(String(s)))
                            }
                        }

                        function t() {
                            for (; this.lastChild;) this.removeChild(this.lastChild);
                            arguments.length && this.append.apply(this, arguments)
                        }

                        function s() {
                            for (var e = this.parentNode, t = arguments.length, s = new Array(t), n = 0; n < t; n++) s[n] = arguments[n];
                            var i = s.length;
                            if (e)
                                for (i || e.removeChild(this); i--;) {
                                    var o = s[i];
                                    "object" != typeof o ? o = this.ownerDocument.createTextNode(o) : o.parentNode && o.parentNode.removeChild(o), i ? e.insertBefore(this.previousSibling, o) : e.replaceChild(o, this)
                                }
                        }
                        "undefined" != typeof Element && (Element.prototype.append || (Element.prototype.append = e, DocumentFragment.prototype.append = e), Element.prototype.replaceChildren || (Element.prototype.replaceChildren = t, DocumentFragment.prototype.replaceChildren = t), Element.prototype.replaceWith || (Element.prototype.replaceWith = s, DocumentFragment.prototype.replaceWith = s))
                    }();
                var v = Object.entries,
                    y = "_splittype",
                    x = {},
                    C = 0;

                function j(e, t, s) {
                    if (!b(e)) return console.warn("[data.set] owner is not an object"), null;
                    var n = e[y] || (e[y] = ++C),
                        i = x[n] || (x[n] = {});
                    return void 0 === s ? t && Object.getPrototypeOf(t) === Object.prototype && (x[n] = c(c({}, i), t)) : void 0 !== t && (i[t] = s), s
                }

                function R(e, t) {
                    var s = b(e) ? e[y] : null,
                        n = s && x[s] || {};
                    return void 0 === t ? n : n[t]
                }

                function L(e) {
                    var t = e && e[y];
                    t && (delete e[t], delete x[t])
                }
                var Q = "\\ud800-\\udfff",
                    U = "\\u0300-\\u036f\\ufe20-\\ufe23",
                    N = "\\u20d0-\\u20f0",
                    O = "\\ufe0e\\ufe0f",
                    E = "[".concat(Q, "]"),
                    k = "[".concat(U).concat(N, "]"),
                    T = "\\ud83c[\\udffb-\\udfff]",
                    A = "(?:".concat(k, "|").concat(T, ")"),
                    W = "[^".concat(Q, "]"),
                    P = "(?:\\ud83c[\\udde6-\\uddff]){2}",
                    q = "[\\ud800-\\udbff][\\udc00-\\udfff]",
                    D = "\\u200d",
                    I = "".concat(A, "?"),
                    B = "[".concat(O, "]?"),
                    M = B + I + ("(?:" + D + "(?:" + [W, P, q].join("|") + ")" + B + I + ")*"),
                    F = "(?:".concat(["".concat(W).concat(k, "?"), k, P, q, E].join("|"), "\n)"),
                    $ = RegExp("".concat(T, "(?=").concat(T, ")|").concat(F).concat(M), "g"),
                    V = RegExp("[".concat([D, Q, U, N, O].join(""), "]"));

                function z(e) {
                    return V.test(e)
                }

                function H(e) {
                    return z(e) ? function(e) {
                        return e.match($) || []
                    }(e) : function(e) {
                        return e.split("")
                    }(e)
                }

                function J(e) {
                    var t, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                    return (e = null == (t = e) ? "" : String(t)) && _(e) && !s && z(e) ? H(e) : e.split(s)
                }

                function Y(e, t) {
                    var s = document.createElement(e);
                    return t ? (Object.keys(t).forEach((function(e) {
                        var n = t[e],
                            i = _(n) ? n.trim() : n;
                        null !== i && "" !== i && ("children" === e ? s.append.apply(s, p(S(i))) : s.setAttribute(e, i))
                    })), s) : s
                }
                var X = {
                    splitClass: "",
                    lineClass: "line",
                    wordClass: "word",
                    charClass: "char",
                    types: ["lines", "words", "chars"],
                    absolute: !1,
                    tagName: "div"
                };

                function G(e, t) {
                    var s, n = d((t = l(X, t)).types),
                        i = t.tagName,
                        o = e.nodeValue,
                        r = document.createDocumentFragment(),
                        c = [];
                    return /^\s/.test(o) && r.append(" "), s = function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
                        return (e ? String(e) : "").trim().replace(/\s+/g, " ").split(t)
                    }(o).reduce((function(e, s, o, a) {
                        var g, u;
                        return n.chars && (u = J(s).map((function(e) {
                            var s = Y(i, {
                                class: "".concat(t.splitClass, " ").concat(t.charClass),
                                style: "display: inline-block;",
                                children: e
                            });
                            return j(s, "isChar", !0), c = [].concat(p(c), [s]), s
                        }))), n.words || n.lines ? (j(g = Y(i, {
                            class: "".concat(t.wordClass, " ").concat(t.splitClass),
                            style: "display: inline-block; ".concat(n.words && t.absolute ? "position: relative;" : ""),
                            children: n.chars ? u : s
                        }), {
                            isWord: !0,
                            isWordStart: !0,
                            isWordEnd: !0
                        }), r.appendChild(g)) : u.forEach((function(e) {
                            r.appendChild(e)
                        })), o < a.length - 1 && r.append(" "), n.words ? e.concat(g) : e
                    }), []), /\s$/.test(o) && r.append(" "), e.replaceWith(r), {
                        words: s,
                        chars: c
                    }
                }

                function K(e, t) {
                    var s = e.nodeType,
                        n = {
                            words: [],
                            chars: []
                        };
                    if (!/(1|3|11)/.test(s)) return n;
                    if (3 === s && /\S/.test(e.nodeValue)) return G(e, t);
                    var i = S(e.childNodes);
                    if (i.length && (j(e, "isSplit", !0), !R(e).isRoot)) {
                        e.style.display = "inline-block", e.style.position = "relative";
                        var o = e.nextSibling,
                            r = e.previousSibling,
                            c = e.textContent || "",
                            a = o ? o.textContent : " ",
                            g = r ? r.textContent : " ";
                        j(e, {
                            isWordEnd: /\s$/.test(c) || /^\s/.test(a),
                            isWordStart: /^\s/.test(c) || /\s$/.test(g)
                        })
                    }
                    return i.reduce((function(e, s) {
                        var n = K(s, t),
                            i = n.words,
                            o = n.chars;
                        return {
                            words: [].concat(p(e.words), p(i)),
                            chars: [].concat(p(e.chars), p(o))
                        }
                    }), n)
                }

                function Z(e) {
                    R(e).isWord ? (L(e), e.replaceWith.apply(e, p(e.childNodes))) : S(e.children).forEach((function(e) {
                        return Z(e)
                    }))
                }

                function ee(e, t, s) {
                    var n, i, o, r = d(t.types),
                        c = t.tagName,
                        p = e.getElementsByTagName("*"),
                        g = [],
                        u = [],
                        l = null,
                        _ = [],
                        m = e.parentElement,
                        f = e.nextElementSibling,
                        b = document.createDocumentFragment(),
                        w = window.getComputedStyle(e),
                        h = w.textAlign,
                        v = .2 * parseFloat(w.fontSize);
                    return t.absolute && (o = {
                        left: e.offsetLeft,
                        top: e.offsetTop,
                        width: e.offsetWidth
                    }, i = e.offsetWidth, n = e.offsetHeight, j(e, {
                        cssWidth: e.style.width,
                        cssHeight: e.style.height
                    })), S(p).forEach((function(n) {
                        var i = n.parentElement === e,
                            o = function(e, t, s, n) {
                                if (!s.absolute) return {
                                    top: t ? e.offsetTop : null
                                };
                                var i = e.offsetParent,
                                    o = a(n, 2),
                                    r = o[0],
                                    c = o[1],
                                    p = 0,
                                    g = 0;
                                if (i && i !== document.body) {
                                    var u = i.getBoundingClientRect();
                                    p = u.x + r, g = u.y + c
                                }
                                var l = e.getBoundingClientRect(),
                                    _ = l.width,
                                    m = l.height,
                                    f = l.x;
                                return {
                                    width: _,
                                    height: m,
                                    top: l.y + c - g,
                                    left: f + r - p
                                }
                            }(n, i, t, s),
                            c = o.width,
                            p = o.height,
                            _ = o.top,
                            m = o.left;
                        /^br$/i.test(n.nodeName) || (r.lines && i && ((null === l || _ - l >= v) && (l = _, g.push(u = [])), u.push(n)), t.absolute && j(n, {
                            top: _,
                            left: m,
                            width: c,
                            height: p
                        }))
                    })), m && m.removeChild(e), r.lines && (_ = g.map((function(e) {
                        var s = Y(c, {
                            class: "".concat(t.splitClass, " ").concat(t.lineClass),
                            style: "display: block; text-align: ".concat(h, "; width: 100%;")
                        });
                        j(s, "isLine", !0);
                        var n = {
                            height: 0,
                            top: 1e4
                        };
                        return b.appendChild(s), e.forEach((function(e, t, i) {
                            var o = R(e),
                                r = o.isWordEnd,
                                c = o.top,
                                a = o.height,
                                p = i[t + 1];
                            n.height = Math.max(n.height, a), n.top = Math.min(n.top, c), s.appendChild(e), r && R(p).isWordStart && s.append(" ")
                        })), t.absolute && j(s, {
                            height: n.height,
                            top: n.top
                        }), s
                    })), r.words || Z(b), e.replaceChildren(b)), t.absolute && (e.style.width = "".concat(e.style.width || i, "px"), e.style.height = "".concat(n, "px"), S(p).forEach((function(e) {
                        var t = R(e),
                            s = t.isLine,
                            n = t.top,
                            i = t.left,
                            r = t.width,
                            c = t.height,
                            a = R(e.parentElement),
                            p = !s && a.isLine;
                        e.style.top = "".concat(p ? n - a.top : n, "px"), e.style.left = "".concat(s ? o.left : i - (p ? o.left : 0), "px"), e.style.height = "".concat(c, "px"), e.style.width = "".concat(s ? o.width : r, "px"), e.style.position = "absolute"
                    }))), m && (f ? m.insertBefore(e, f) : m.appendChild(e)), _
                }
                var te = l(X, {}),
                    se = function() {
                        function e(t, s) {
                            ! function(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                            }(this, e), this.isSplit = !1, this.settings = l(te, f(s)), this.elements = h(t), this.split()
                        }
                        return i(e, null, [{
                            key: "clearData",
                            value: function() {
                                Object.keys(x).forEach((function(e) {
                                    delete x[e]
                                }))
                            }
                        }, {
                            key: "setDefaults",
                            value: function(e) {
                                return te = l(te, f(e)), X
                            }
                        }, {
                            key: "revert",
                            value: function(e) {
                                h(e).forEach((function(e) {
                                    var t = R(e),
                                        s = t.isSplit,
                                        n = t.html,
                                        i = t.cssWidth,
                                        o = t.cssHeight;
                                    s && (e.innerHTML = n, e.style.width = i || "", e.style.height = o || "", L(e))
                                }))
                            }
                        }, {
                            key: "create",
                            value: function(t, s) {
                                return new e(t, s)
                            }
                        }, {
                            key: "data",
                            get: function() {
                                return x
                            }
                        }, {
                            key: "defaults",
                            get: function() {
                                return te
                            },
                            set: function(e) {
                                te = l(te, f(e))
                            }
                        }]), i(e, [{
                            key: "split",
                            value: function(e) {
                                var t = this;
                                this.revert(), this.elements.forEach((function(e) {
                                    j(e, "html", e.innerHTML)
                                })), this.lines = [], this.words = [], this.chars = [];
                                var s = [window.pageXOffset, window.pageYOffset];
                                void 0 !== e && (this.settings = l(this.settings, f(e)));
                                var n = d(this.settings.types);
                                n.none || (this.elements.forEach((function(e) {
                                    j(e, "isRoot", !0);
                                    var s = K(e, t.settings),
                                        n = s.words,
                                        i = s.chars;
                                    t.words = [].concat(p(t.words), p(n)), t.chars = [].concat(p(t.chars), p(i))
                                })), this.elements.forEach((function(e) {
                                    if (n.lines || t.settings.absolute) {
                                        var i = ee(e, t.settings, s);
                                        t.lines = [].concat(p(t.lines), p(i))
                                    }
                                })), this.isSplit = !0, window.scrollTo(s[0], s[1]), v(x).forEach((function(e) {
                                    var t = a(e, 2),
                                        s = t[0],
                                        n = t[1],
                                        i = n.isRoot,
                                        o = n.isSplit;
                                    i && o || (x[s] = null, delete x[s])
                                })))
                            }
                        }, {
                            key: "revert",
                            value: function() {
                                this.isSplit && (this.lines = null, this.words = null, this.chars = null, this.isSplit = !1), e.revert(this.elements)
                            }
                        }]), e
                    }()
            },
            "./src/assets/images/Section10_icon1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_icon1.png"
            },
            "./src/assets/images/Section10_icon2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_icon2.png"
            },
            "./src/assets/images/Section10_icon3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_icon3.png"
            },
            "./src/assets/images/Section10_icon4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_icon4.png"
            },
            "./src/assets/images/Section10_icon5.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_icon5.png"
            },
            "./src/assets/images/Section10_icon6.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_icon6.png"
            },
            "./src/assets/images/Section10_mob_image1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_mob_image1.jpg"
            },
            "./src/assets/images/Section10_web_image1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section10_web_image1.jpg"
            },
            "./src/assets/images/Section11_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section11_web_image1.png"
            },
            "./src/assets/images/Section11_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section11_web_image2.png"
            },
            "./src/assets/images/Section12_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section12_web_image1.png"
            },
            "./src/assets/images/Section12_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section12_web_image2.png"
            },
            "./src/assets/images/Section13_sign1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section13_sign1.png"
            },
            "./src/assets/images/Section13_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section13_web_image1.png"
            },
            "./src/assets/images/Section13_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section13_web_image2.png"
            },
            "./src/assets/images/Section14_icon1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_icon1.png"
            },
            "./src/assets/images/Section14_icon2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_icon2.png"
            },
            "./src/assets/images/Section14_icon3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_icon3.png"
            },
            "./src/assets/images/Section14_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_web_image1.png"
            },
            "./src/assets/images/Section14_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_web_image2.png"
            },
            "./src/assets/images/Section14_web_image3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_web_image3.png"
            },
            "./src/assets/images/Section14_web_image4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section14_web_image4.png"
            },
            "./src/assets/images/Section15_mob_phone.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section15_mob_phone.png"
            },
            "./src/assets/images/Section15_petsnaps.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section15_petsnaps.jpg"
            },
            "./src/assets/images/Section15_phone.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section15_phone.png"
            },
            "./src/assets/images/Section15_phone_product.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section15_phone_product.png"
            },
            "./src/assets/images/Section15_watch.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section15_watch.jpg"
            },
            "./src/assets/images/Section16_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section16_web_image1.png"
            },
            "./src/assets/images/Section1_mob_image1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section1_mob_image1.jpg"
            },
            "./src/assets/images/Section1_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section1_web_image1.png"
            },
            "./src/assets/images/Section21_web_image1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image1.jpg"
            },
            "./src/assets/images/Section21_web_image10.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image10.jpg"
            },
            "./src/assets/images/Section21_web_image11.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image11.jpg"
            },
            "./src/assets/images/Section21_web_image12.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image12.jpg"
            },
            "./src/assets/images/Section21_web_image2.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image2.jpg"
            },
            "./src/assets/images/Section21_web_image3.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image3.jpg"
            },
            "./src/assets/images/Section21_web_image4.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image4.jpg"
            },
            "./src/assets/images/Section21_web_image5.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image5.jpg"
            },
            "./src/assets/images/Section21_web_image6.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image6.jpg"
            },
            "./src/assets/images/Section21_web_image7.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image7.jpg"
            },
            "./src/assets/images/Section21_web_image8.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image8.jpg"
            },
            "./src/assets/images/Section21_web_image9.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section21_web_image9.jpg"
            },
            "./src/assets/images/Section2_mob_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_mob_image1.png"
            },
            "./src/assets/images/Section2_mob_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_mob_image2.png"
            },
            "./src/assets/images/Section2_mob_image3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_mob_image3.png"
            },
            "./src/assets/images/Section2_mob_image4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_mob_image4.png"
            },
            "./src/assets/images/Section2_mob_image5.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_mob_image5.png"
            },
            "./src/assets/images/Section2_mob_image6.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_mob_image6.png"
            },
            "./src/assets/images/Section2_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_web_image1.png"
            },
            "./src/assets/images/Section2_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_web_image2.png"
            },
            "./src/assets/images/Section2_web_image3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_web_image3.png"
            },
            "./src/assets/images/Section2_web_image4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_web_image4.png"
            },
            "./src/assets/images/Section2_web_image5.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_web_image5.png"
            },
            "./src/assets/images/Section2_web_image6.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section2_web_image6.png"
            },
            "./src/assets/images/Section3_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section3_web_image1.png"
            },
            "./src/assets/images/Section4_sign1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section4_sign1.png"
            },
            "./src/assets/images/Section4_sign2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section4_sign2.png"
            },
            "./src/assets/images/Section4_sign3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section4_sign3.png"
            },
            "./src/assets/images/Section4_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section4_web_image1.png"
            },
            "./src/assets/images/Section4_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section4_web_image2.png"
            },
            "./src/assets/images/Section4_web_image4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section4_web_image4.png"
            },
            "./src/assets/images/Section5_sign1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section5_sign1.png"
            },
            "./src/assets/images/Section5_sign2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section5_sign2.png"
            },
            "./src/assets/images/Section5_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section5_web_image1.png"
            },
            "./src/assets/images/Section5_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section5_web_image2.png"
            },
            "./src/assets/images/Section6_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section6_web_image1.png"
            },
            "./src/assets/images/Section6_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section6_web_image2.png"
            },
            "./src/assets/images/Section7_sign1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section7_sign1.png"
            },
            "./src/assets/images/Section7_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section7_web_image1.png"
            },
            "./src/assets/images/Section7_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section7_web_image2.png"
            },
            "./src/assets/images/Section8_web_image1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section8_web_image1.png"
            },
            "./src/assets/images/Section8_web_image2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section8_web_image2.png"
            },
            "./src/assets/images/Section8_web_image3.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section8_web_image3.png"
            },
            "./src/assets/images/Section8_web_image4.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section8_web_image4.png"
            },
            "./src/assets/images/Section9_icon1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section9_icon1.png"
            },
            "./src/assets/images/Section9_mob_image1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section9_mob_image1.jpg"
            },
            "./src/assets/images/Section9_sign1.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section9_sign1.png"
            },
            "./src/assets/images/Section9_sign2.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section9_sign2.png"
            },
            "./src/assets/images/Section9_web_image1.jpg": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section9_web_image1.jpg"
            },
            "./src/assets/images/Section_compare_EdgeC.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_EdgeC.png"
            },
            "./src/assets/images/Section_compare_l.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_l.png"
            },
            "./src/assets/images/Section_compare_master.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_master.png"
            },
            "./src/assets/images/Section_compare_maxV.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_maxV.png"
            },
            "./src/assets/images/Section_compare_plus.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_plus.png"
            },
            "./src/assets/images/Section_compare_pro.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_pro.png"
            },
            "./src/assets/images/Section_compare_qrevo.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_qrevo.png"
            },
            "./src/assets/images/Section_compare_s.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_s.png"
            },
            "./src/assets/images/Section_compare_series.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_series.png"
            },
            "./src/assets/images/Section_compare_slim.png": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section_compare_slim.png"
            },
            "./src/assets/video/Section3_video.mp4": function(e, t, s) {
                "use strict";
                e.exports = s.p + "files/qrevoc_Section3_video.mp4"
            },
            jquery: function(e) {
                "use strict";
                e.exports = $
            }
        },
        t = {};

    function s(n) {
        var i = t[n];
        if (void 0 !== i) return i.exports;
        var o = t[n] = {
            exports: {}
        };
        return e[n](o, o.exports, s), o.exports
    }
    s.m = e, s.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return s.d(t, {
                a: t
            }), t
        }, s.d = function(e, t) {
            for (var n in t) s.o(t, n) && !s.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            })
        }, s.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, s.p = "/cdn/shop/", s.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            s("./src/index.html"), s("./src/widgets/index.js"), s("./src/js/main.js")
        }()
}();